module.exports = __webpack_public_path__ + "static/media/compare_92.d1a37a2e.svg";